import {
  ArrowsUpIcon,
  ElectricIcon,
  Food2Icon,
  FridgeIcon,
  IntercomIcon,
  LockGadgetIcon,
  SafeIcon,
  ShieldCheckeredIcon,
  ShieldLockIcon,
  WorkbenchIcon,
} from "@/shared/icons";

export const improvementsIconsList = {
  smartalarm: ShieldLockIcon,
  fooddelivery: Food2Icon,
  workbench: WorkbenchIcon,
  wardrobe: ArrowsUpIcon,
  safe: SafeIcon,
  intercom: IntercomIcon,
  extrafridge: FridgeIcon,
  security: ShieldCheckeredIcon,
  elock: LockGadgetIcon,
  echarger: ElectricIcon,
};
